export const lg_joinmeetbtid = {
  lg_joinmeetbtid_th: {
    title: "เข้าร่วมการประชุมผ่าน Dmeets",
    subtitle1: "กรุณากรอกรหัสการประชุมที่ท่านได้รับเพื่อเข้าร่วมการประชุม",
    subtitle2: "ข้อมูลการประชุมทั้งหมดถูกจัดเก็บในประเทศไทย",
    subtitle3:
      "Dmeets รับรองว่าการประชุมออนไลน์ของคุณปลอดภัยและเป็นไปตามกฎหมาย PDPA ข้อมูลการประชุมทั้งหมดของคุณจะไม่ถูกจัดเก็บไว้นอกประเทศไทย",
    formlabel: "เข้าร่วมประชุมด้วย Meeting ID",
    formplaceholder: "รหัสการประชุม",
    buttonjoin: "เข้าร่วมการประชุม",
    put_required: "ใส่รหัสการประชุม!!!",
    jm_page_label: "การประชุมออนไลน์ที่ปลอดภัย",
    jm_heading: "เข้าร่วมการประชุม\nตอนนี้",
    jm_subheading:
      "กรอกรหัสการประชุมหรือวางลิงก์ที่ได้รับจากเจ้าของการประชุมเพื่อเข้าร่วมได้ทันที",
    jm_benefit1: "การเข้าถึงการประชุมที่ปลอดภัย",
    jm_benefit2: "ตั้งค่าก่อนเข้าผ่านเบราว์เซอร์",
    jm_benefit3: "จัดเก็บข้อมูลการประชุมในไทย",
    jm_card_title: "เข้าร่วมการประชุม",
    jm_card_desc: "กรอกรหัสการประชุมหรือวางลิงก์ที่ได้รับจากเจ้าของการประชุม",
    jm_code_label: "รหัสหรือลิงก์การประชุม",
    jm_code_placeholder: "กรอกรหัสการประชุม",
    jm_code_helper: "ตัวอย่าง: 922 517",
    jm_paste: "วาง",
    jm_continue: "ดำเนินการต่อ",
    jm_checking: "กำลังตรวจสอบการประชุม…",
    jm_or: "หรือ",
    jm_already_account: "มีบัญชี Dmeets อยู่แล้ว?",
    jm_signin_link: "เข้าสู่ระบบเพื่อดำเนินการต่อ",
    jm_trust_title: "การเชื่อมต่อของคุณปลอดภัย",
    jm_trust_desc: "Dmeets ดูแลข้อมูลการประชุมของคุณและจัดเก็บในประเทศไทย",
  },
  lg_joinmeetbtid_en: {
    title: "Join a Meeting on Dmeets",
    subtitle1: "Please enter the Meeting ID you received to join the meeting.",
    subtitle2: "Your meeting is secure. All data is stored in Thailand.",
    subtitle3:
      "Dmeets ensure your online meetings are safe and PDPA-compliant. All of your meetings will not be stored outside of Thailand.",
    formlabel: "Join Meeting with ID",
    formplaceholder: "Meeting ID",
    buttonjoin: "Join Meeting",
    put_required: "Meeting ID required",
    jm_page_label: "Secure video meetings",
    jm_heading: "Join your meeting\nin seconds",
    jm_subheading:
      "Enter a meeting code or paste the meeting link sent by your host to join instantly.",
    jm_benefit1: "Secure meeting access",
    jm_benefit2: "Browser-based pre-join setup",
    jm_benefit3: "PDPA-conscious data handling",
    jm_card_title: "Join a Meeting",
    jm_card_desc:
      "Enter your meeting code or paste the meeting link provided by the host.",
    jm_code_label: "Meeting code or link",
    jm_code_placeholder: "Enter meeting code",
    jm_code_helper: "Example: 922 517",
    jm_paste: "Paste",
    jm_continue: "Continue",
    jm_checking: "Checking meeting…",
    jm_or: "or",
    jm_already_account: "Already have a Dmeets account?",
    jm_signin_link: "Sign in to continue",
    jm_trust_title: "Your meeting connection is secure",
    jm_trust_desc:
      "Dmeets handles your meeting data responsibly. All meeting infrastructure is operated within Thailand.",
  },
};
